import { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Collapse,
  Grid,
  List,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import { useAppSelector } from '../../app/hooks';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useWeatherWallsByFolder } from './api/getWeatherWallsByFolder';
import { useWeatherWallsWithoutFolders } from './api/getWeatherWallsWithoutFolders';

const WeatherWallList = () => {
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);
  const { data: folders } = useWeatherWallsByFolder({ userId: user?.id || -1 });
  const { data: wallsWithoutFolders } = useWeatherWallsWithoutFolders({
    userId: user?.id,
  });
  const [selectedWallId, setSelectedWallId] = useState(-1);
  const [foldersOpenStatus, setFoldersOpenStatus] = useState<{
    [id: number]: boolean;
  }>({});

  const handleWallClicked = (wallId: number) => {
    setSelectedWallId(wallId);
    navigate(`/weather-wall/${wallId}`);
  };

  const handleFolderClicked = (folderId: number) => {
    const currentFolderStatus = foldersOpenStatus[folderId];
    const newFolderStatusState = { ...foldersOpenStatus };
    newFolderStatusState[folderId] = !currentFolderStatus;
    setFoldersOpenStatus(newFolderStatusState);
  };

  return (
    <div>
      <List>
        {folders?.map((folder) => (
          <Fragment key={folder.id + 'fragment'}>
            <ListItemButton
              onClick={() => handleFolderClicked(folder.id)}
              key={folder.id + 'folder'}
            >
              <ListItemText>
                <Grid container alignItems='center'>
                  {folder.name}
                </Grid>
              </ListItemText>
              {foldersOpenStatus[folder.id] ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse
              in={foldersOpenStatus[folder.id]}
              timeout='auto'
              unmountOnExit
            >
              {folder.weatherWalls.map((wall) => (
                <ListItemButton
                  onClick={() => handleWallClicked(wall.id)}
                  key={wall.id + 'wall'}
                  selected={selectedWallId === wall.id}
                  sx={{ pl: '2rem' }}
                >
                  <ListItemText>{wall.name}</ListItemText>
                </ListItemButton>
              ))}
            </Collapse>
          </Fragment>
        ))}
        {wallsWithoutFolders?.map((wall) => (
          <ListItemButton
            onClick={() => handleWallClicked(wall.id)}
            key={wall.id + 'wallnofolder'}
            selected={selectedWallId === wall.id}
          >
            <ListItemText>{wall.name}</ListItemText>
          </ListItemButton>
        ))}
      </List>
    </div>
  );
};

export default WeatherWallList;
